import React from 'react';
import NavBar from './NavBar.jsx';

import VerticalLinkCollection from './VerticalLinkCollection.jsx';
import ReactDOM from 'react-dom';

import RecursiveTable from './RecursiveField.jsx';
import RecursiveField2 from './RecursiveField2.jsx';
import UpdateDataForm from './UpdateDataForm.jsx';
import ChangePositionView from './ChangePositionView.jsx';
import {DropDownMultiSelector} from "./DropDownSelector.jsx";
import * as tools from "./tools.jsx";



class Account extends React.Component {
   constructor(props)
   {
      super(props);
      this.state = {
         data_tags:[],
         testActiveIds:[],
         testActiveSingleId:null,
      };

      this.linkColCB = function(elemClicked)
      {
         console.log("clicked name: " + elemClicked.name + " id: " + elemClicked.id);
   
         this.props.changePageCallback(elemClicked);
      }.bind(this);

      this.multiSelectorTestVals =[];
      /*
      for(var i = 0; i < 400; i++)
      {
         const name = tools.makeid(1) + "_" + i;
         this.multiSelectorTestVals.push({id:i, name:name});
      }
      */

      this.navLinks =  [
         //{id:"account", name:"Account"},
         {id:"users", name:"users"},
         {id:"contexts", name:"contexts"},
         {id:"compositions", name:"compositions"},
         {id:"playlists", name:"playlists"},
         {id:"tags", name: "Tags"},
         
         {id:"testAPI", name:"Test API"},
         ];
         if(true/*this.props.user.role_id == 3*/)
         {
            this.navLinks = [...this.navLinks, {id:"prefabAudio", name: "Prefab Audio"} ] 
         }
   }

   refreshData()
   {
   //Get tags for testing
      this.props.appCallbacks.performAjaxRequest("tags", "GET", null,
      tools.getSetBaseDataFunc(this, "data_tags"), false);
   }

   componentDidMount()
   {
      this.refreshData();
   }

   render() {

      var verticalStyle =
      {
         verticalAlign:'top',
         display: 'inline-block',
         //padding: '30px 0 0 0',
         //height: '100%',
      }

      var spacerStyle =
      {
         width: 50,
         display: 'inline-block',
         //padding: '30px 0 0 0',
         //height: '100%',
      }
      var navigateStyle =
      {
         verticalAlign:'center',
         //width: 50,
         display: 'inline-block',
         padding: '0 10px 0 0',
         //height: '100%',
      }
      
      //const multiDropDownObjects = this.state.data_tags.map((t)=>{return {id:t.tag_id, name:"#"+t.name}});
      return (
         <div>
            <h1>Welcome {this.props.user.name}</h1>
            <div style={verticalStyle}>
            <table>
               <tbody>
                  <tr>
                     <td>Name:</td><td>{this.props.user.name}</td>
                  </tr>
                  <tr>
                     <td>Email:</td><td>{this.props.user.email}</td>
                  </tr>
                  <tr>
                     <td>Role:</td><td>{this.props.user.role_name}</td>
                  </tr>
               </tbody>
            </table>
         </div>
         <div style={spacerStyle}>
         </div>
         <div style={navigateStyle}>
            Navigate to:
         </div>
         <div style = {verticalStyle}>
           
               <VerticalLinkCollection
                  links = {this.navLinks}
                  clickElemCallback = {this.linkColCB} />
            
         </div>
         <div style={{clear:'both'}}></div>
         <div>
            <a>Guide til workshopledere</a>
            <br/>
            <a style={{color:"#646463"}} href="https://docs.google.com/document/d/1Mdl6k0186TT_fcPyJSABdPDWS6UqhKpWR9420WHivvk/export?format=pdf" download>(Download pdf)</a>
         </div>
         {/*<DropDownMultiSelector objects={this.multiSelectorTestVals}
         value={this.state.testActiveIds}
             onChange={(result)=>{console.log("Canged to: ");console.log(result); this.setState({testActiveIds:result})}}/>

         <DropDownMultiSelector objects={this.multiSelectorTestVals} selectSingle={true}
         value={this.state.testActiveSingleId}
             onChange={(result)=>{console.log("Canged to: ");console.log(result); this.setState({testActiveSingleId:result})}}/>
          */}
      </div>
      );
   }
}

export default Account ;


// WEBPACK FOOTER //
// ./js/Account.jsx